





























import Vue from 'vue';
import { axiosApiInstance } from '../../utils/axiosInstances';
import NumDataDisplay from '../DashboardView/Summary/NumDataDisplay.vue';

export default Vue.extend({
  components: {
    NumDataDisplay,
  },
  props: ['isLabelset'],
  data(): {
    name: string;
    description: string;
  } {
    return {
      name: '',
      description: '',
    };
  },
  async created() {
    let result: any = {};
    if (!this.$route.params.labelsetId) {
      result = await axiosApiInstance.get(
        `/api/v1/datasets/${this.$route.params.datasetId}`,
      );
    } else {
      result = await axiosApiInstance.get(
        `/api/v1/labelsets/${this.$route.params.labelsetId}`,
      );
    }
    const data = result.data.result;
    this.name = data.name;
    this.description = data.description;
  },
  computed: {
    badDataNumber(): any {
      if (this.isLabelset)
        return this.$store.getters.schemaAnalysisResult.badLabelNumber;
      else return this.$store.getters.badDataNumber;
    },
    totalDataNumber(): any {
      if (this.isLabelset)
        return this.$store.getters.schemaAnalysisResult.totalLabelNumber;
      else return this.$store.getters.totalDataNumber;
    },
  },
});
